
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { Operation } from '../operation/operation';
import { Revision } from '../revision/revision';
import { Dossier } from '../dossier/dossier';
import { RecordLink } from '../record-link/record-link';
import { Execution, ExecutionDossier } from './execution';
import { ExecutionService } from './execution.service';
import { NotifierService, DialogService } from '../ui';
import { DossierModel } from '../dossier-model/dossier-model';

@Component({
  templateUrl: './execution-for-dossier.component.html',
})
export class ExecutionForDossierComponent implements OnInit {

  execution: Execution
  dossier: Dossier
  dossierModel: DossierModel

  selectedLinks: RecordLink[]
  selectedOperation: Operation
  selectedRevision: Revision
  showOperationFilter: boolean = false;

  title: string

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private executionService: ExecutionService,
    private notifier: NotifierService,
    private builder: FormBuilder,
    private dialogService: DialogService
  ) { }

  ngOnInit() {

    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.title = data.title;
      
      this.dossier = data.dossier;
      this.dossierModel = data.dossierModel;

      this.selectedLinks = [];

      this.execution = new Execution();
      this.execution.dossiers = [
        new ExecutionDossier({
          id: this.dossier.id,
          root_field: '',
          dossier: this.dossier,
        }),
      ];
      this.execution.dossier_model = this.dossierModel;

      this.notifier.endProgress();
    });
  }

  save(dossiers: ExecutionDossier[]) {
    this.execution.links = this.selectedLinks;
    this.execution.operation = this.selectedOperation;
    this.execution.revision = this.selectedRevision;

    this.execution.dossiers.push(...dossiers);

    if (!this.execution || !this.execution.valid) {
      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    this.executionService
      .create(this.execution).pipe(
      finalize(onComplete))
      .subscribe((execution) => {
        this.execution = execution;

        this.notifier.success('Execution créée avec succès');

        // Got to edit screen
        this.router.navigate(['dossiers', this.dossier.id, 'execute', execution.id]);
      });
  }

  cancel() {
    this.selectedOperation = null;
    this.selectedRevision = null;
  }

  applyFilter() {
    this.showOperationFilter = true;
  }
}
